import InvestigationalUseDialog from './InvestigationalUseDialog';

export default InvestigationalUseDialog;
